import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import React from 'react'
import { CMSState } from '../../../../cms/blocks/types.gen'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { getImageSize } from '../../../utils/extra_images.mod'
import { WordPress } from '../../../../wordpress/wordpress_api'
import { PublicSiteState } from '../../../../public_site.main.mod'

export type QuoteBlockProps<extra_images> = {
  text: string
  author?: string
  link_title?: string
  link_url?: string
  image?: WordPress.Image
  image_alt?: string

  show_in_page_navigation: boolean
  navigation_title: string
}

export type QuoteBlockStyle = Partial<{
  block_classname: string
  footer_classname: string
  inner_classname: string
  content_classname: string
  text_classname: string
  quote_classname: string
  visual_classname: string
  image_classname: string
  author_classname: string
  clickable_classname: string
}>

export function QuoteBlock<customBlockData, extra_images>(
  props: QuoteBlockProps<extra_images>,
  options?: { style?: QuoteBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (
    s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>
  ) => (public_state: PublicSiteState) =>
      mk_widget({
        run: _ => (
          <section
            id={props.navigation_title}
            className={getClassName(options, "block_classname", "")}
            key={options && options.key ? options.key : "quote-block" + Math.random()}
          >
            <div className={getClassName(options, "inner_classname", "")}>
              <div className={getClassName(options, "content_classname", "")}>
                <div className={getClassName(options, "text_classname", "")}>
                  <blockquote
                    className={getClassName(options, "quote_classname", "")}
                    dangerouslySetInnerHTML={{ __html: props.text }}
                  />

                  {props.author && (
                    <figcaption
                      className={getClassName(options, "author_classname", "")}
                    >
                      {props.author}
                    </figcaption>
                  )}

                  {props.link_title && props.link_url && (
                    <footer
                      className={getClassName(options, "footer_classname", "")}
                    >
                      <a
                        href={props.link_url}
                        className={getClassName(
                          options,
                          "clickable_classname",
                          ""
                        )}
                      >
                        {props.link_title}
                      </a>
                    </footer>
                  )}
                </div>

                <figure
                  className={getClassName(options, "visual_classname", "")}
                >
                  {props.image ? (
                    <img
                      src={getImageSize<extra_images>(props.image, "1240x1240")}
                      data-src={getImageSize(props.image, '1240x1240')}
                      data-srcset={[
                        [getImageSize(props.image, '310x310') + ' 310w'],
                        [getImageSize(props.image, '620x620') + ' 620w'],
                        [getImageSize(props.image, '1240x1240') + ' 1240w'],
                      ]}
                      className={getClassName(options, "image_classname", "")}
                      width="1240"
                      height="1240"
                      alt={
                        props.image_alt
                          ? props.image_alt
                          : props.author
                            ? props.author
                            : ""
                      }
                    />
                  ) : (
                      <svg
                        className="block__icon"
                        width="346px"
                        height="260px"
                      >
                        <use xlinkHref="#quotes" />
                      </svg>
                    )}
                </figure>
              </div>
            </div>
          </section>
        )
      });
}



// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/widgets/quoteBlock.mod.tsx